export const VideoQuality = {
  fullHd: { label: 'FullHD video', value: 1080 },
  hd: { label: 'HD video', value: 720 },
  sq: { label: '360p', value: 360 },
};
